import { apiClient } from "./client";
import type {
  SavedViewCreate,
  SavedViewEntity,
  SavedViewRead,
  SavedViewUpdate,
} from "./types";

export async function listViews(
  slug: string,
  entity?: SavedViewEntity,
): Promise<SavedViewRead[]> {
  const res = await apiClient.get<SavedViewRead[]>(
    `/projects/${slug}/views`,
    { params: entity ? { entity } : undefined },
  );
  return res.data;
}

export async function createView(
  slug: string,
  data: SavedViewCreate,
): Promise<SavedViewRead> {
  const res = await apiClient.post<SavedViewRead>(
    `/projects/${slug}/views`,
    data,
  );
  return res.data;
}

export async function updateView(
  slug: string,
  id: number,
  data: SavedViewUpdate,
): Promise<SavedViewRead> {
  const res = await apiClient.patch<SavedViewRead>(
    `/projects/${slug}/views/${id}`,
    data,
  );
  return res.data;
}

export async function deleteView(slug: string, id: number): Promise<void> {
  await apiClient.delete(`/projects/${slug}/views/${id}`);
}

export async function setDefault(
  slug: string,
  id: number,
): Promise<SavedViewRead> {
  const res = await apiClient.post<SavedViewRead>(
    `/projects/${slug}/views/${id}/set-default`,
  );
  return res.data;
}

export async function unsetDefault(
  slug: string,
  id: number,
): Promise<SavedViewRead> {
  const res = await apiClient.post<SavedViewRead>(
    `/projects/${slug}/views/${id}/unset-default`,
  );
  return res.data;
}

// F3-bis deleted the three default-all wrappers (fetchDefaultAll /
// upsertDefaultAll / resetDefaultAll). The backend routes
// /projects/{slug}/views/default-all are still reachable but no
// longer called from the frontend — a separate cleanup PR will
// remove them server-side along with the is_default_all column.
